import i18n from 'i18next'

export const dateFormatter = (options, date) =>
  new Intl.DateTimeFormat(i18n.language, options).format(date)

/**
 * Format a date for use in batch names.
 * For en-US, uses ISO format (YYYY-MM-DD) to avoid ambiguous MM/DD vs DD/MM.
 * For other locales, uses their locale-specific date format.
 */
export const formatDateForBatchName = (date: Date, locale = i18n.language || 'en-US'): string => {
  return locale === 'en-US'
    ? date.toISOString().split('T')[0]
    : new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(date)
}

export const getDateYear = (date) =>
  dateFormatter(
    {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    },
    date,
  )

const DIVISIONS: { amount: number; name: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, name: 'seconds' },
  { amount: 60, name: 'minutes' },
  { amount: 24, name: 'hours' },
  { amount: 7, name: 'days' },
  { amount: 4.34524, name: 'weeks' },
  { amount: 12, name: 'months' },
  { amount: Number.POSITIVE_INFINITY, name: 'years' },
]

export const formatTimeAgo = (date: string): [string, number] => {
  const formatter = new Intl.RelativeTimeFormat(i18n.language, {
    numeric: 'auto',
  })

  // @ts-expect-error
  const secondsAgo = (new Date(date) - new Date()) / 1000
  let duration = secondsAgo

  for (let i = 0; i <= DIVISIONS.length; i += 1) {
    const division = DIVISIONS[i]
    if (Math.abs(duration) < division.amount) {
      return [
        formatter.format(Math.round(duration), division.name),
        Math.abs(Math.round(secondsAgo)),
      ]
    }
    duration /= division.amount
  }

  return ['never', 0]
}
